<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">小乐手表绑定</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="序列号" required prop="imei">
                                    <el-input v-model="addForm.imei" placeholder="请输入名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="绑定老人" required prop="userName">
                                    <el-input v-model="addForm.userName" placeholder="请选择绑定老人" disabled>
                                        <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            
                            
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
        <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeGetElderly="showModalGetElderly=false"  v-on:setElderly="setElderly"></GetElderly>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import GetElderly from "./GetElderly";
    import { getInstitutionCode } from "@/utils/auth";

    export default {
        name: 'Add',
        props:['setmealList'],
        data() {
            return {
                loading: false,
                showModalGetElderly: false,
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    plateform:'institution',
                    phone:'',
                    userCode:'',
                    zoneCode:'',
                    zoneCodePath:'',
                    zoneCodePathName:'',
                    zoneName:'',
                    userName:'',
                    governmentCode:getInstitutionCode(),
                    imei:''
                },
                rules:{
                    imei:[
                        { required: true, message: '请输入序列号', trigger: 'blur' },
                    ],
                    userName:[
                        { required: true, message: '请选择老人', trigger: 'blur' }
                    ]
                }
            }
        },
        components:{
            GetElderly
        },
        methods: {
            init(){
                this.$refs.addForm.resetFields();
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            getElderly(){
                this.showModalGetElderly = !this.showModalGetElderly;
                this.$refs.myGetElderly.init();
            },
            setElderly(row){
                this.addForm.userCode=row.userCode;
                this.addForm.phone = row.phone;
                this.addForm.userName = row.name;
                this.addForm.idCard = row.idCard;
                console.log(this.addForm)
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$deviceUrl+"DeviceTogWatch/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$message({type: 'success', message: '绑定成功'});
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
                /deep/ .el-input.is-disabled .el-input__inner {
                    background: white;
                    color:  #606266;
                }
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
